/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'

import { AsyncStateN, Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth/atoms'
import { UnknownError } from '@root/shared'
import { CancelError } from '@root/shared'

import { Unlocked } from '../model/storage-session'

import { storageSessionStateAtom } from './reatom-secure-storage-state'

import type { Redacted } from '@blade/std-lib'

export interface CreatePasswordController {
  onInitialized: (args: { password: Redacted.Redacted }) => void
  onCancel: () => void
}

export const createPasswordControllerAtom = atom<
  CreatePasswordController | undefined
>(undefined)

type Result_ = Result.Result<
  { password: Redacted.Redacted | undefined },
  CancelError | UnknownError
>
export const ensureStorageIsInitializedAction = action(
  async (ctx): Promise<Result_> => {
    const promise = new Promise<Result_>((resolve) => {
      const process = async () => {
        const storageSessionState = ctx.get(storageSessionStateAtom)
        if (!AsyncStateN.isSuccess(storageSessionState)) {
          const delugeId = ctx.get(delugeIdAtom)
          if (!delugeId) {
            resolve(Result.fail(UnknownError.fromUnknown()))
            return
          }
          await ctx.schedule(() =>
            storageSessionStateAtom.execute(ctx, delugeId),
          )
        }

        const storageSession = ctx.get(storageSessionStateAtom).value
        if (!storageSession) {
          resolve(Result.fail(UnknownError.fromUnknown()))
          return
        }

        if (storageSession instanceof Unlocked) {
          resolve(Result.succeed({ password: undefined }))
          return
        }

        createPasswordControllerAtom(ctx, {
          onInitialized: ({ password }) => {
            createPasswordControllerAtom(ctx, undefined)
            resolve!(Result.succeed({ password }))
          },
          onCancel: () => {
            createPasswordControllerAtom(ctx, undefined)
            resolve!(Result.fail(CancelError.make()))
          },
        })
      }
      process()
    })

    return promise
  },
  'ensureStorageIsInitializedAction',
)
